<template lang="pug">
v-dialog(
  v-model="dialog",
  fullscreen,
  hide-overlay,
  transition="dialog-bottom-transition"
)
  v-btn(
    v-if="dialogType === 'form'",
    slot="activator",
    dark,
    color="indigo",
    title="View Detail"
  )
    v-icon print
    | &nbsp; Print Preview

  template(v-slot:activator="{ on, attrs }")
    v-icon.mr-2(
      v-if="dialogType !== 'form'",
      slot="activator",
      small,
      title="View Detail",
      v-bind="attrs",
      v-on="on",
      @click="getPreviewConfig"
      color="blue"
      :id="'loginActionPreviewMemo_' + imItems.imNo"
    ) remove_red_eye

  v-card
    v-app-bar.navFixed(:color="themeColor", height="48px;")
      img.mr-2(
        :src="headerLogo",
        height="34",
        @click="$router.push('/')",
        style="cursor: pointer"
      )
      v-toolbar-title(
        style="cursor: pointer; font-size: 18px; font-weight: 600; color: white"
      ) i-Memo Preview 
      v-spacer
      v-toolbar-items
        v-btn(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || (imItems.imStatus == 3 && isMyNeedReview(imItems.imReturn) ) ) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)",
          flat,
          title="Approval",
          @click="approvalDialog = true",
          dark,
          text
        ) 
          v-icon(id="loginViewAppvDialogButton" title="Approval") assignment_turned_in
          | &nbsp;Approval
        v-dialog(
          v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)",
          v-model="approvalDialog",
          persistent,
          max-width="500px"
        )
          v-card
            v-card-title.headline.grey.lighten-3.mb-3 Approval Form
            v-card-text
              v-layout(wrap)
                v-flex(xs12)
                  //- v-radio-group(id="loginViewAppvDialogStatusRadioGroup" v-model="approval", row)
                  //-   v-radio(id="loginViewAppvDialogApprove"
                  //-     v-if="imItems.imStatus != 3",
                  //-     label="Approve",
                  //-     color="success",
                  //-     value="7"
                  //-   )
                  //-   v-radio(id="loginViewAppvDialogReject" 
                  //-     v-if="imItems.imStatus != 3",
                  //-     label="Reject",
                  //-     color="red",
                  //-     value="8"
                  //-   )
                  //-   v-radio(id="loginViewAppvDialogReview" 
                  //-     label="Need Review",
                  //-     color="yellow darken-4",
                  //-     value="3"
                  //-   )
                  //- .mb-2(v-if="approval == 3", style="color: #000000") Please select the user to revise/review the memo. Approver will start from the selected user.
                //- v-flex(v-if="approval == 3", xs12)
                //-   v-select(
                //-     id="loginViewAppvDialogReviewerDropdown" 
                //-     v-if="imItems.imUseAlias",
                //-     v-model="select",
                //-     :hint="jabatan",
                //-     :items="reviewer",
                //-     item-text="alias",
                //-     item-value="id",
                //-     label="Select",
                //-     persistent-hint,
                //-     return-object,
                //-     single-line,
                //-     dense
                //-   )
                //-   v-select(
                //-     id="loginViewAppvDialogReviewerDropdown" 
                //-     v-else,
                //-     v-model="select",
                //-     :hint="jabatan",
                //-     :items="reviewer",
                //-     item-text="name",
                //-     item-value="id",
                //-     label="Select",
                //-     persistent-hint,
                //-     return-object,
                //-     single-line,
                //-     dense
                //-   )
                v-flex(xs12)
                  //- v-textarea.mt-3(
                  //-   id="loginViewAppvDialogCommentBox" 
                  //-   v-model="comment",
                  //-   filled,
                  //-   label="Comment (Optional)",
                  //-   counter="150",
                  //-   :rules="[rules.length(150)]"
                  //- )
                  
                  div(style="display: flex; align-items: left; height: 80px; width: 100%; border: 1px solid #ccc; padding: 20px; text-align: left; position: relative;")
                    img(src="/img/icons/warning.png" width="50px" style="margin-right:1vw")
                    p(style="font-size: 16px; color:black") For approval, please use the link provided in the email or WhatsApp message. Thank you




            v-card-actions.pb-5
              v-spacer
              v-btn.pl-4.pr-4(id="loginViewAppvDialogClose"  depressed, @click="handleClose")
                | Close

              //- v-btn.pl-4.pr-4(
              //-   :disabled="(!select.hasOwnProperty('id') && approval == 3) || (comment != null && comment.length > 150) || approval == null",
              //-   color="blue-secondary",
              //-   depressed,
              //-   @click="submit"
              //-   :loading="btnLoader"
              //-   id="loginViewAppvDialogSubmit" 
              //- ) Submit

              v-dialog(
                v-model="approvalDialog2"
                hide-overlay
                persistent
                width="300"
              )
                v-card(color="primary" dark)
                  v-card-text Processing. Please wait!
                    v-progress-linear(indeterminate color="white" class="mb-0")

        v-menu(offset-y v-if="imItems.imFileLampiran")
          template(v-slot:activator="{ on, attrs }" v-if="imItems.imFileLampiran.length > 0")
            v-btn(
              text
              dark
              v-bind="attrs"
              v-on="on"
            )
              v-icon cloud_download
              | &nbsp; Attachments

          v-list(v-if="imItems.imFileLampiran.length > 0")
            v-list-item(
              v-for="(item, index) in imItems.imFileLampiran"
              :key="index"
            )
              v-list-item-title 
                a(@click="downloadFile(item.url)")
                  | {{ item.name |truncate(50, '...')  }}.{{extractExtension(item.url)}}
            br(v-if="imItems.imFileLampiran.length > 1")
            hr(v-if="imItems.imFileLampiran.length > 1") 
            v-list-item(v-if="imItems.imFileLampiran.length > 1")
              v-list-item-title 
                a(@click="downloadAllFile(imItems.imNo)")
                  | Download All (Zip)

        v-btn(dark, text, @click="printIM(imItems._id)")
          v-icon print
          | &nbsp; Print

        v-btn(v-if="imItems.imStatus==4" dark text @click="shareIM()")
          v-icon share
          | &nbsp; Share
        v-dialog(v-model="share" persistent max-width="350px")
          v-card
              v-card-title(class="headline grey lighten-2") Share
              v-flex(class="text-center")
                ShareNetwork(v-for="network in networks" :key="network.key" :network="network.network" :title="network.network=='whatsapp' ? 'Subject: '+ sharing.title+' \\nBody: \\n' : sharing.title " :url="shortUrl" :description="sharing.description")
                  img(:src="network.img" width="80px" style="margin:20px 15px;")
              v-spacer
              v-flex(class="text-right pa-4")
                v-btn( class="custom__padding-btn elevation-0" @click.native="share=false") Close


        v-btn(dark, text, @click.native="dialog = false")
          v-icon(title="Close") cancel
          | &nbsp;Close
    v-list.print-bg.padTop60(three-line, subheader)
      div(:id="imItems._id" style="height: 100%; min-height: 100vh;")
        .page(size="Auto")
          table#header-view.view-width.print-header(
            style="margin-bottom: 1.2rem"
          )
            tbody
              tr
                td.custom-td(
                  :style="`justify-content: ${dataPreview.logo_position}; display:flex`"
                  v-if="dataPreview.logo != ''"
                )
                  div(
                    style="display: flex; width: auto; flex-direction: column; align-items: center; flex-direction: column"
                  )
                    img.height-60px(v-if="imItems.imUseLogo !== 'false' && imItems.imUseLogo !== false" :src="dataPreview.logo") 
                    p.logo-title(v-show="dataPreview.show_name" style="text-align:center") {{ dataPreview.bu_name }}
                    p.fw-300.tagline(v-show="dataPreview.show_tagline" style="text-align:center") {{ dataPreview.tagline }}

          .view-width(style="font-size: 14px")
            h2(style="text-align: center; padding: 5px") {{imItems.imType == 6 ? 'PAYMENT REQUEST': imItems.imType == 5 ?'INTERNAL MEMO' : 'ANNOUNCEMENT'}}
            hr.custom-hr

            table.view-width(v-if="imItems.imType != 7" style="margin-top: 10px")
              tbody
                tr
                  td(style="font-size: 15px; width: 40%") 
                    strong To
                    i.fw-300 &nbsp;Kepada
                  td(style="font-size: 15px")
                    strong From
                    i.fw-300 &nbsp;Dari

                tr
                  td(valign="top")
                    ul.mt-n1
                      li(
                        v-for="(requestor, i) in imItems.imWorkflow.slice().reverse()",
                        :key="i",
                        style="font-size: 15px",
                        v-if="requestor.status != 5"
                      )
                        span {{ imItems.imUseAlias ? requestor.alias : requestor.name }}
                  td(valign="top")
                    ul.list-creator.mt-n1
                      li
                        span {{ imItems.imUseAlias ? imItems.imUser.alias : imItems.imUser.name }}
                      li 
                        strong Number
                        i.fw-300 &nbsp;Nomor
                        br
                        | {{ imItems.imNo }}
                      li
                        strong Date
                        i.fw-300 &nbsp;Tanggal
                        br
                        | {{ imItems.imReSubmitedDate && imItems.imReSubmitedDate != null ? getTanggal(imItems.imReSubmitedDate) : imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                      li(v-if="imItems.hasOwnProperty('imCategory') && imItems.imType == 5")
                        strong Category
                        i.fw-300  Kategori
                        br
                        | {{ imItems.imCategory }}
                      li(v-if="imItems.imType")
                        strong Subject
                        i.fw-300  Subjek
                        br
                        p(style="text-align:justify") {{ imItems.imPerihal }}

                tr
                  td(style="font-size: 15px; width: 40%") 
                    strong CC
                    i.fw-300 &nbsp;Tembusan
                    span(v-if="imItems.imCC == null || imItems.imCC.length == 0") &nbsp;-

                tr(v-if="imItems.imCC != null") 
                  td(valign="top")
                    span(
                      v-for="(cc, index) in imItems.imCC",
                      v-if="index !== imItems.imCC.length - 1",
                      style="font-size: 15px"
                    ) {{ imItems.imUseAlias ? cc.alias : cc.name }},&nbsp;
                    span(v-else) {{ imItems.imUseAlias ? cc.alias : cc.name }}&nbsp;


            table.view-width(v-if="imItems.imType == 7" style="margin-top: 10px")
              tbody
                tr(style="margin:2px")
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong No
                    span(style="font-style:italic; font-weight:400") &nbsp; Nomor
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(valign="top" style="font-size: 15px")
                    h5(style="font-size: 15px; font-weight: 400; text-align: justify;") {{ imItems.imNo }}
                tr(style="margin:2px")
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong To
                    span(style="font-style:italic; font-weight:400") &nbsp; Kepada
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(valign="top" style="font-size: 15px")
                    h5(style="font-size: 15px; font-weight: 400; text-align: justify;") {{ imItems.imAnchTo }}
                tr(style="margin:2px")
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong From
                    span(style="font-style:italic; font-weight:400") &nbsp; Dari
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(valign="top" style="font-size: 15px")
                    h5(style="font-size: 15px; font-weight: 400; text-align: justify;") {{ imItems.imAnchFrom }}
                tr(style="margin:2px")
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong Date
                    span(style="font-style:italic; font-weight:400") &nbsp; Tanggal
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(valign="top" style="font-size: 15px")
                    h5(style="font-size: 15px; font-weight: 400; text-align: justify;") {{ imItems.imReSubmitedDate && imItems.imReSubmitedDate != null ? getTanggal(imItems.imReSubmitedDate) : imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                tr(style="margin:2px")
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong Subject
                    span(style="font-style:italic; font-weight:400") &nbsp; Subjek
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(valign="top" style="font-size: 15px")
                    h5(style="font-size: 15px; font-weight: 400; text-align: justify;") {{ imItems.imPerihal }}
                tr( style="margin:2px" )
                  td(valign="top" style="font-size: 15px; width: 18%") 
                    strong CC
                    span(style="font-style:italic; font-weight:400") &nbsp; Tembusan
                    
                  td(valign="top" style="font-size: 15px;") 
                    | :
                  td(v-if="imItems.imCC == null || imItems.imCC.length == 0") &nbsp;-
                  td( v-if="imItems.imCC != null && imItems.imCC.length != 0" valign="top" style="font-size: 15px")
                    div(style="display:flex")
                      h5(
                        style="font-size: 15px; font-weight: 400; text-align: justify;"
                        v-for="(cc, index) in imItems.imCC",
                        v-if="index !== imItems.imCC.length - 1",
                      ) {{ imItems.imUseAlias ? cc.alias : cc.name }},&nbsp;
                      h5(style="font-size: 15px; font-weight: 400; text-align: justify;" v-else) {{ imItems.imUseAlias ? cc.alias : cc.name }}&nbsp;

            hr.custom-hr

            .content-memo(v-if="imItems.imType == 5")
              strong Purpose
              i.fw-300 &nbsp;Tujuan
              .ck-content(v-html="imItems.imTujuan")
            .content-memo(v-if="imItems.imType == 5")
              strong Background
              i.fw-300 &nbsp;Latar Belakang
              .ck-content(v-html="imItems.imLatarBelakang")
            .content-memo(v-if="imItems.imType == 5")
              strong Propose
              i.fw-300 &nbsp;Mengusulkan
              .ck-content(v-html="imItems.imUsulan")
            .content-memo(v-if="imItems.imType == 7")
              strong Details
              i.fw-300 &nbsp;Detail
              .ck-content(v-html="imItems.imAnchDetail")
            div(v-if="imItems.imType == 5")
              span(style="font-weight: 500px") We are hereby submitting our request, your consideration and approval are highly appreciated. Thank you.
              br
              i.fw-300 Demikian permohonan ini kami buat, atas persetujuan Bapak/Ibu, kami ucapkan terima kasih.
            div(v-if="imItems.imType == 6")
              div(class="imPayBox")
                strong(class="imPayTTL") Business Unit 
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Unit Bisnis
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imOrganization.name}}
              
              div(class="imPayBox")
                strong(class="imPayTTL") Invoice No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Faktur
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataInvoiceNo? imItems.imPayDataInvoiceNo: '-'}}
              div(class="imPayBox")
                strong(class="imPayTTL") Invoice Date
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Tanggal Faktur
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataInvoiceDate? imItems.imPayDataInvoiceDate: '-'}}
              div(class="imPayBox")
                strong(class="imPayTTL") Tax No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Pajak
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataTaxNo ? imItems.imPayDataTaxNo : '-'}}
              div(class="imPayBox")
                strong(class="imPayTTL") Purpose
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Tujuan
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imTujuan}}

              div(class="imPayBox" style="background: #F3F4F6; margin: 0.5rem 0;")
                strong(class="imPayTTL") Pay To
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Bayar Kepada
              
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Bank
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataBankName}}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account No.
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nomor Bank
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataBankNo}}
              div(class="imPayBox")
                strong(class="imPayTTL") Bank Account Name
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Nama Akun Bank
                strong : &nbsp;
                h5(class="imPayText") {{imItems.imPayDataPayTo}}

            hr.custom-hr(style="margin-top: 2rem")

          div(v-if="imItems.imType == 6" style="font-size: 14px;")
            strong Payment Details
            i.fw-300 &nbsp;Rincian Pembayaran
            table.view-width(
              id="tablePaymentView",
              border="1",
              style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: left; z-index: 100; font-size"
            )
              tbody 
                tr(style="background: #f3f4f6")
                  td(style="padding-left: 1rem;" width="50%") 
                    b Items
                  td(style="padding-left: 1rem;" width="50%") 
                    b Amount
                tr(v-for="item in imItems.imPaymentData.paymentItems" )
                  td(style="padding-left: 1rem;" width="50%") {{item.name}}
                  td(style="padding-left: 1rem;" width="50%") 
                    div(style="display:flex")
                      money(
                        disabled
                        style="width: 100%; height: 61%;border-radius: 5px; padding-left: 0.5rem; "
                        v-model="item.amount" 
                        v-bind="getMoneyFormat(imItems.imPaymentData.paymentCurrency.text)"
                      )
                tr(style="background: #f3f4f6")
                  td(style="padding-left: 1rem;" width="50%") 
                    b Total Amount
                  td(style="padding-left: 1rem;" width="50%") 
                    div(style="display:flex")
                      money(
                        disabled
                        style="width: 100%; height: 61%;border-radius: 5px; padding-left: 0.5rem; font-weight:bold"
                        v-model="imItems.imPaymentData.paymentTotal" 
                        v-bind="getMoneyFormat(imItems.imPaymentData.paymentCurrency.text)"
                      )
            hr.custom-hr(style="margin-top: 2rem")
        .page.pagebreak(size="Auto", style="height: auto")
          strong Approval list for
          i(class="fw-300") &nbsp;Daftar persetujuan untuk
          p(style="font-size: 14px") No. {{ imItems.imNo }}

          .view-width.detail-wrap(
            style="position: relative; font-size: 14px; height: auto"
          )

            div(:class="setWmPosition()" v-if="wm.src != null")
              img(:src="wm.src")

            div(id="background" v-else)
              div(v-if="imItems.imStatus == 1")
                img.imgWaterMark(src="img/draft.png")
                //- .text-rotate.im-draft {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 2")
                img.imgWaterMark-on-approval(src="img/on-approval.png")
                //- .text-rotate.im-on-approval {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 4")
                img.imgWaterMark-fully-approved(src="img/fully-approved.png")
                //- .text-rotate.im-fully-approved {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 5")
                img.imgWaterMark(src="img/withdraw.png")
                //- .text-rotate.im-withdraw {{ imItems.imNo }}

              div(v-if="imItems.imStatus == 8")
                img.imgWaterMark(src="img/rejected.png")
                //- .text-rotate.im-rejected {{ imItems.imNo }}

            table.view-width(
              id="tblAppvDtl"
              border="1",
              style="margin: 10px 0; border: 1px solid black; border-collapse: collapse; text-align: center; z-index: 100"
            )
              tbody
                tr
                  td(colspan="3", style="") 
                    b Submitted by
                    i.fw-300 &nbsp;Diajukan Oleh
                tr(style="background: #f3f4f6")
                  td(width="36%") 
                    b Name
                      span(v-if="imItems.imHideTitle == false") &nbsp;& Position
                    br
                    i.fw-300 Nama
                      span(v-if="imItems.imHideTitle == false") &nbsp;& Jabatan
                  td(width="32%") 
                    b Comment
                    br
                    i.fw-300 Komentar
                  td(width="32%")
                    b Digital Signature
                    br
                    i.fw-300 Tanda Tangan Digital
                tr(height="80px")
                  td.px-3(width="40%")
                    b {{ imItems.imUseAlias ? imItems.imUser.alias : imItems.imUser.name }} {{ imItems.imHideTitle ? '' : '/ ' + imItems.imUser.position }}
                  td 
                    div(
                      v-if="imItems.imStatus == 3 && imItems.imWorkflow[0].status == 6"
                    ) Under Review

                    div(v-else-if="imItems.imStatus == 5 && imItems.imWorkflow[0].hasOwnProperty('comment')") {{ imItems.imWorkflow[0].user == imItems.imUser.name? imItems.imWorkflow[0].comment :`-`}}
                  td 
                    .approved(v-if="imItems.imStatus == 5 && imItems.imWorkflow[0].user == imItems.imUser.name")
                      img(:src="dataPreview.icon_withdraw", style="height: 30px;")
                      br
                      | {{ 'Withdraw' + (getWithdrawDate ? ' at ' + getTanggal(getWithdrawDate) : '') }}<br />
                    .approved(v-else-if="imItems.imStatus == 5")
                      img(:src="dataPreview.icon_full_approve", style="height: 30px;")
                      br
                      | {{ (  getTanggal(imItems.imDate)) }}<br />
                    .approved(v-else-if="imItems.imStatus == 1") &nbsp;
                    .approved(
                      v-else-if="!(imItems.imStatus == 3 && imItems.imWorkflow[0].status == 6)"
                    )
                      img(:src="dataPreview.icon_full_approve", style="height: 30px;")
                      br
                      | {{ imItems.imReSubmitedDate && imItems.imReSubmitedDate != null ? getTanggal(imItems.imReSubmitedDate) : imItems.imDate ? getTanggal(imItems.imDate) : '-' }}
                    .approved(v-else-if="imItems.imStatus == 3") {{ imItems.imDate ? getTanggal(imItems.imDate) : '-' }}

                tr
                  td(colspan="3", align="center", style="") 
                    b Approved by
                    i.fw-300 &nbsp;Disetujui Oleh
                tr(style="background: #f3f4f6")
                  td(width="36%") 
                    b Name
                      span(v-if="imItems.imHideTitle == false") &nbsp;& Position
                    br
                    i.fw-300 Nama
                      span(v-if="imItems.imHideTitle == false") &nbsp;& Jabatan
                  td(width="32%") 
                    b Comment
                    br
                    i.fw-300 Komentar
                  td(width="32%")
                    b Digital Signature
                    br
                    i.fw-300 Tanda Tangan Digital

                tr(
                  v-for="(item, index) in imItems.imWorkflow",
                  v-if="item.status != 5",
                  height="80px"
                )
                  td.px-3(width="40%")
                    b {{ imItems.imUseAlias ? item.alias : item.name }} {{ imItems.imHideTitle ? '' : item.position ? '/ ' + item.position : '' }}
                  td(v-if="imItems.imStatus == 3")
                    div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                    div(
                      v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)"
                    ) 
                      //- | Returned to {{ imItems.imUseAlias ? imItems.imReturn[imItems.imReturn.length-1].alias : imItems.imReturn[imItems.imReturn.length-1].name }}
                      //- br
                      | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? `${item.comment}` : '' }}
                      //- br
                      //- | (Need Reapproval)
                    div(v-else) {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 ? item.comment : '' }}
                  td(
                    v-else-if="imItems.imStatus != 3 && imItems.hasOwnProperty('imReturn')"
                  )
                    div()
                      | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) || ( imItems.imWorkflow[0].comment !== null &&  imItems.imWorkflow[0].comment !== '' &&  imItems.imWorkflow[0].comment !== undefined && (imItems.imWorkflow[0].user == item.name || imItems.imWorkflow[0].user)) ? imItems.imWorkflow[0].user == item.name || imItems.imWorkflow[0].user == item.alias ?imItems.imWorkflow[0].comment: item.comment : '' }}
                    //- div(
                    //-   v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length - 1].id && item.status != 7"
                    //- ) 
                    //-   //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                    //-   //- br
                    //-   | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                    //- div(
                    //-   v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length - 1].id"
                    //- ) 
                    //-   | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                    //-   //- br
                    //-   //- | (Need Reapproval)
                    //- div(
                    //-   v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length - 1].id"
                    //- ) 
                    //-   | {{ item.comment !== null && item.comment !== '' && item.comment !== undefined ? item.comment : '' }}
                    //-   //- br
                    //- div(v-else) {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 && imItems.imStatus != 5 ? item.comment : '' }}
                  td(v-else)
                    div {{ item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9 && imItems.imStatus != 5 ? item.comment : '' }}
                  td
                    template(v-if="item.status == 3 && (imItems.imWorkflow[0].user == item.name || imItems.imWorkflow[0].user == item.alias)")
                      .approved() 
                        img(:src="dataPreview.icon_withdraw", style="height: 30px;")
                        br
                        | {{ getTanggal(imItems.imWorkflow[0].date) }}<br />
                    template(v-if="imItems.imStatus != 5")
                      .approved(v-if="item.status == 7") 
                        img(:src="dataPreview.icon_full_approve", style="height: 30px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      .approved(v-else-if="imItems.imStatus == 3 && item.date") 
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      .approved(v-else-if="item.status == 8") 
                        img(:src="dataPreview.icon_reject", style="height: 30px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      .approved(
                        v-else-if="imItems.imStatus == 2 && imItems.hasOwnProperty('imReturn') && item.date"
                      )
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      .approved(
                        v-else-if="imItems.imStatus == 8 && imItems.hasOwnProperty('imReturn') && item.date"
                      )
                        | {{ getTanggal(item.date) }}
                      .approved.ff0000(v-else) &nbsp; <br />&nbsp; <br />&nbsp; <br />

            div(
              style="text-align: center; margin-top: 1rem; margin-bottom: 1rem"
            )
              div(
                style="font-size: 14px; font-weight: bold; color: red; text-align: center"
              ) QR code to validate the correctness of the information on the digital signature in this document.
              i.fw-300 Kode QR untuk memvalidasi kebenaran informasi pada tanda tangan digital dalam dokumen ini.
            p(style="text-align: center")
              img(
                :src="'data:image/png;base64, ' + imItems.qrcode",
                style="vertical-align: middle; width: 150px"
              )

          //- WATERMARK STATUS SHOW WHEN PRINT    
          div(v-if="wm.src == null")
            div(v-if="imItems.imStatus == 1")
              img.imgWaterMarkPrint(src="img/draft.png")
              //- .text-rotate.im-draft-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 2")
              img.imgWaterMark-on-approval-print(src="img/on-approval.png")
              //- .text-rotate.im-on-approval-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 4")
              img.imgWaterMark-fully-approved-print(src="img/fully-approved.png")
              //- .text-rotate.im-fully-approved-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 5")
              img.imgWaterMarkPrint-withdraw-print(src="img/withdraw.png")
              //- .text-rotate.im-withdraw-print {{ imItems.imNo }}

            div(v-if="imItems.imStatus == 8")
              img.imgWaterMark-rejected-print(src="img/rejected.png")
              //- .text-rotate.im-rejected-print {{ imItems.imNo }}


          div(class="divFooter") 
            img(:src="'data:image/png;base64, '+imItems.qrcode" width="50px")

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )
</template>

<script>
import axios from "axios";
import md5 from "md5";
import { Money } from "v-money";
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
export default {
  components: {
    components: { Money },
  },
  name: "imView",
  props: {
    dialogType: String,
    imItems: Object,
    userDetail: Object,
    currencyConfigs: Object,
  },
  data: () => ({
    // currencyConfigs: {
    // },
    dataPreview: {
      code: null,
      bu_name: null,
      logo: null,
      logo_position: "left",
      tagline: null,
      show_name: false,
      show_tagline: false,
      themeColor: "#D42A2A",
      headerLogo: require("../assets/imemo-white.png"),
      icon_full_approve: require("../assets/check-64.png"),
      icon_reject: require("../assets/close-64.png"),
      icon_withdraw: require("../assets/withdraw-64.png"),
    },
    i18n: i18n.default,
    dialog: false,
    approvalBtn: false,
    approvalDialog: false,
    approvalDialog2: false,
    dialogTg: false,
    tgDontRemind: false,
    comment: null,
    approvalflag: false,
    approval: null,
    kepadas: [],
    select: {},
    print: false,
    share: false,
    forwardNote: null,
    userForward: {},
    forwardDialog: false,
    users: [],
    qrImage: `/img/icons/loading.gif`,
    showImg: false,
    overlay: false,
    rules: {
      length: (len) => (v) =>
        (v || "").length <= len || `Comment must be less than 150 characters`,
    },
    shortUrl: "",
    wm: {
      src: null,
      position: null,
      rotate: null,
      size: null,
    },
    btnLoader: false,
  }),
  created(){

    // this.fetchCurrencyConfigs()
    
  },
  computed: {
    themeColor() {
      return this.$store.getters.getThemeColor;
    },
    headerLogo() {
      return this.$store.getters.getLogoNoText;
    },
    ...mapState(["sharing", "shortenUrl", "dataUsers", "networks"]),
    reverseImApprover: function () {
      return this.imItems.imApprover.slice().reverse();
    },
    getWithdrawDate: function () {
      let result = "";
      for (const item of this.imItems.imWorkflow) {
        if (item.status == 5) {
          result = item.date;
          break;
        }
      }
      return result;
    },
    reviewer: function () {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if (wf.status == 9 || wf.status == 3) break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function () {
      if (this.select === this.imItems.imUser) {
        return this.select.position + " (Initiator)";
      }
      return this.select.position;
    },
    titleUser: function () {
      return this.userForward.title;
    },
    treasuryApprovers: function () {
      return this.imItems.imWorkflow.slice(
        0,
        this.imItems.imWorkflow.length - 2
      );
    },
    validators: function () {
      return this.imItems.imWorkflow.slice(this.imItems.imWorkflow.length - 2);
    },
    //- getCategory() {
    //-   let result = "";
    //-   for ( const item of this.i18n.category ) {
    //-     if ( item.value == this.imItems.imCategory ) {
    //-       result = item.text;
    //-       break;
    //-     }
    //-   }
    //-   return result;
    //- }
  },
  mounted: async function () {
    // ubah memo use alias untuk special users
    const special_user = process.env.SPECIAL_USER;
    if (special_user) {
      let special_users = special_user.split(",");
      if (special_users.length > 0) {
        this.imItems.imUseAlias = special_users.includes(this.$store.state.dataUsers.user._id) ? false : this.imItems.imUseAlias;
        this.imItems.imHideTitle = special_users.includes(this.$store.state.dataUsers.user._id) ? false : this.imItems.imHideTitle;
      }
    }

    // this.$store.dispatch("fetchDataCompanies")
    if (!this.approvalflag) {
      if (this.dialogType === "ho") {
        this.approvalflag = true;
        // this.approval = this.imItems.imStatus == 3 ? "3" : "4";
      } else {
        this.approvalflag = true;
        // this.approval = this.imItems.imStatus == 3 ? "3" : "7";
      }
    }
    //- let userDatas = await this.getUsers();
    //- for (const item of userDatas.data) {
    //-   this.users.push(item);
    //- }

    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.qrImage =
        process.env.VUE_APP_API_OLD +
        `/qr/generate/${this.imItems.imNo}/${this.imItems.imType}`;
    });
  },
  methods: {

    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
      } catch (error) {
        console.error('Error fetching currency configurations:', error)
        // Fallback to default configurations...
      }
    },
    isMyNeedReview: function (itemRtDetail) {
      const loginedUserBu = this.$store.state.dataUsers.user.bu;

      for (let i in loginedUserBu) {
        //- for(let j in itemRtDetail) {
        if (loginedUserBu[i].id == itemRtDetail[itemRtDetail.length - 1].id) {
          return true;
          //- }
        }
      }
      return false;
    },
    extractExtension(url) {
      // Memecah URL menjadi bagian-bagian yang dipisahkan oleh titik (.)
      const parts = url.split(".");
      // Mengambil ekstensi yang terletak di bagian terakhir
      const extension = parts[parts.length - 1];
      return extension;
    },
    handleClose() {
      this.approval = null;
      this.approvalDialog = false;
    },
    shareIM: function () {
      this.$store
        .dispatch("getShortenUrl", { im: this.imItems })
        .then((res) => {
          this.shortUrl = res.data;
          this.share = true;
        });
    },
    getPreviewConfig() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_API +
            `/business-unit/detail/${this.imItems.imOrganization.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          (this.dataPreview.code = res.data.bu_code),
            (this.dataPreview.bu_name = res.data.name),
            (this.dataPreview.logo = res.data.logo),
            (this.dataPreview.logo_position = res.data.logo_align),
            (this.dataPreview.tagline = res.data.tagline),
            (this.dataPreview.show_name = res.data.is_show_name),
            (this.dataPreview.show_tagline = res.data.is_show_tagline);

          //- this.dataPreview.themeColor = res.data.settings.themeColors

          //- if ( res.data.hasOwnProperty('settings') && res.data.settings.hasOwnProperty('headerLogo') && res.data.settings.headerLogo.src != null ) {
          //-   this.dataPreview.headerLogo = res.data.settings.headerLogo.src
          //- }

          if (
            res.data.hasOwnProperty("settings") &&
            res.data.settings.hasOwnProperty("approvalSignIcon") &&
            res.data.settings.approvalSignIcon.src != null
          ) {
            this.dataPreview.icon_full_approve =
              res.data.settings.approvalSignIcon.src;
          }

          if (
            res.data.hasOwnProperty("settings") &&
            res.data.settings.hasOwnProperty("rejectionSignIcon") &&
            res.data.settings.rejectionSignIcon.src != null
          ) {
            this.dataPreview.icon_reject =
              res.data.settings.rejectionSignIcon.src;
          }

          if (
            res.data.hasOwnProperty("settings") &&
            res.data.settings.hasOwnProperty("withdrawSignIcon") &&
            res.data.settings.withdrawSignIcon.src != null
          ) {
            this.dataPreview.icon_withdraw =
              res.data.settings.withdrawSignIcon.src;
          }

          if (this.imItems.imStatus == 1) {
            if (
              res.data.hasOwnProperty("settings") &&
              res.data.settings.hasOwnProperty("draftWatermark")
            ) {
              this.wm.src = res.data.settings.draftWatermark.src;
              this.wm.position = res.data.settings.draftWatermark.align;
              this.wm.rotate = res.data.settings.draftWatermark.rotate;
              this.wm.size = res.data.settings.draftWatermark.size;
            }
          } else if (this.imItems.imStatus == 2) {
            if (
              res.data.hasOwnProperty("settings") &&
              res.data.settings.hasOwnProperty("onApprovalWatermark")
            ) {
              this.wm.src = res.data.settings.onApprovalWatermark.src;
              this.wm.position = res.data.settings.onApprovalWatermark.align;
              this.wm.rotate = res.data.settings.onApprovalWatermark.rotate;
              this.wm.size = res.data.settings.onApprovalWatermark.size;
            }
          } else if (this.imItems.imStatus == 4) {
            if (
              res.data.hasOwnProperty("settings") &&
              res.data.settings.hasOwnProperty("fullApprovedWatermark")
            ) {
              this.wm.src = res.data.settings.fullApprovedWatermark.src;
              this.wm.position = res.data.settings.fullApprovedWatermark.align;
              this.wm.rotate = res.data.settings.fullApprovedWatermark.rotate;
              this.wm.size = res.data.settings.fullApprovedWatermark.size;
            }
          } else if (this.imItems.imStatus == 5) {
            if (
              res.data.hasOwnProperty("settings") &&
              res.data.settings.hasOwnProperty("withdrawWatermark")
            ) {
              this.wm.src = res.data.settings.withdrawWatermark.src;
              this.wm.position = res.data.settings.withdrawWatermark.align;
              this.wm.rotate = res.data.settings.withdrawWatermark.rotate;
              this.wm.size = res.data.settings.withdrawWatermark.size;
            }
          } else if (this.imItems.imStatus == 8) {
            if (
              res.data.hasOwnProperty("settings") &&
              res.data.settings.hasOwnProperty("rejectedWatermark")
            ) {
              this.wm.src = res.data.settings.rejectedWatermark.src;
              this.wm.position = res.data.settings.rejectedWatermark.align;
              this.wm.rotate = res.data.settings.rejectedWatermark.rotate;
              this.wm.size = res.data.settings.rejectedWatermark.size;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401 || err.response.status == 403) {
            return this.$router.push("/logout");
          }
          this.overlay = false;
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    },
    submit() {
      this.btnLoader = true;
      this.approvalDialog2 = true;
      let token = localStorage.getItem("token");
      let person = "";
      let find = this.imItems.imStatus == 3 ? 3 : 9;
      for (let i in this.imItems.imWorkflow) {
        if (this.imItems.imWorkflow[i].status == find)
          person = this.imItems.imWorkflow[i];
      }
      let config = {
        method: "put",
        url:
          process.env.VUE_APP_API_OLD +
          `/api/v2/update/requests/${this.$store.state.dataUsers.user._id}`,
        headers: { Authorization: `Bearer ${token}` },
        data: {
          _id: this.imItems._id,
          status: parseInt(this.approval),
          person,
          comment: this.comment,
          backto: parseInt(this.approval) == 3 ? this.select : null,
        },
      };
      axios(config)
        .then((res) => {
          if (res.status == 200) {
            this.approvalDialog = false;
            this.approvalDialog2 = false;
            this.btnLoader = false;
            this.$toasted.success(res.data.message, { icon: "check_circle" });
            setTimeout(() => {
              location.reload();
            }, 3000);
          }
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.$toasted.error(
              err.response.data.message + ", please reload your page",
              { icon: "error" }
            );
            this.approvalDialog2 = false;
          } else {
            this.approvalDialog2 = false;
            this.$toasted.error(err.response.data.error, { icon: "error" });
          }
        })
        .finally(() => {
          this.btnLoader = false;
        });
    },
    printIM: function (id) {
      printJS({
        printable: id,
        type: "html",
        scanStyles: false,
        css: [
          "/stylesheets/approval.css",
          "/stylesheets/vuetify.min.css",
          "/stylesheets/ck-content.css",
        ],
      });
    },
    getTanggal: function (tgl) {
      //- let monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
      let tanggal = new Date(tgl);
      //- let month = tanggal.getMonth();
      let date =
        tanggal.getDate() < 10 ? "0" + tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString("default", { month: "short" });
      let hour =
        tanggal.getHours() < 10 ? "0" + tanggal.getHours() : tanggal.getHours();
      let minutes =
        tanggal.getMinutes() < 10
          ? "0" + tanggal.getMinutes()
          : tanggal.getMinutes();
      return (
        date +
        " " +
        month +
        " " +
        tanggal.getFullYear() +
        " " +
        hour +
        ":" +
        minutes
      );
    },
    setWmPosition() {
      if (
        this.wm.position != null ||
        this.wm.rotate != null ||
        this.wm.size != null
      ) {
        let position =
          this.wm.position == "left"
            ? "img-wm__position-left"
            : this.wm.position == "center"
            ? "img-wm__position-center"
            : this.wm.position == "right"
            ? "img-wm__position-right"
            : "img-wm__position-default";

        let rotate = "";

        if (this.wm.rotate) {
          if (this.wm.position == "left") {
            rotate = "img-wm__rotate-90-left";
          } else if (this.wm.position == "center") {
            rotate = "img-wm__rotate-90-center";
          } else {
            rotate = "img-wm__rotate-90-right";
          }
        } else {
          rotate = "";
        }

        let size =
          this.wm.size == "large" ? "img-wm__size-xl" : "img-wm__size-l";

        return position + " " + rotate + " " + size;
      } else {
        return "img-wm__default";
      }
    },
    countLeadtime: function (d1, d2) {
      const tgl1 = new Date(d1);
      const tgl2 = new Date(d2);
      const date1 = new Date(
        tgl1.getFullYear() + "-" + (tgl1.getMonth() + 1) + "-" + tgl1.getDate()
      );
      const date2 = new Date(
        tgl2.getFullYear() + "-" + (tgl2.getMonth() + 1) + "-" + tgl2.getDate()
      );
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    //- download(files) {
    //-   for (const key in files) {
    //-     window.open(files[key].url, '_blank');
    //-   }
    //- },
    downloadFile(files) {
      window.open(files, "_blank");
    },
    downloadAllFile(imNo) {
      //- window.location.href=process.env.VUE_APP_API+`/requests/download_zip/`+imNo
      this.overlay = true;
      const URL = process.env.VUE_APP_API + `/requests/download_zip/` + imNo;
      axios
        .head(URL)
        .then((response) => {
          const statusCode = response.status;
          if (statusCode === 404 || statusCode === 500) {
            this.overlay = false;
            this.$toasted.error("Download failed!", { icon: "error" });
          } else {
            this.overlay = false;
            window.location.href = URL;
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error("Download failed!", { icon: "error" });
        });
    },
    getMoneyFormat(currency) {
      return this.currencyConfigs[currency] || this.currencyConfigs.USD;
    },
  },
};
</script>

<style>
div.ck-content ol li img {
  max-width: 100%;
}

div.ck-content ul li img {
  max-width: 100%;
}
</style>

<style scoped>
.print-bg {
  background: rgb(204, 204, 204) !important;
}
.print-bg > div {
  text-align: center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin: 0 auto;
  display: inline-block;
  text-align: initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding: 0 3px;
}
.padding-xy-5 {
  padding: 2px;
}
.padding-xy-1 {
  padding: 1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding: 8px 5px 0px;
  width: 35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width: 20%;
}
.width-25p {
  width: 25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align: top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top: 60px;
}
.blink {
  -webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #fff;
}
@-webkit-keyframes blink {
  to {
    color: #ffffff;
  }
}
@keyframes blink {
  to {
    color: #ffffff;
  }
}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin: 0 auto;
    display: block;
    text-align: initial;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .pagebreak {
    page-break-before: always;
  } /* page-break-after works, as well */
  p {
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
  .image {
    padding: 5%;
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
  .table {
    page-break-after: auto;
    page-break-before: auto;
    page-break-inside: avoid;
  }
}
#background {
  position: absolute;
  z-index: 0;
  display: block;
  top: 0px;
  left: 0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 10%;
  position: absolute;
  top: 0px;
  right: 10px;
}

/* ========== CUSTOM CSS =========== */
.fw-300 {
  font-weight: 300;
}

ul.list-creator {
  list-style-type: none;
  padding-left: 0;
}

ul.list-creator li {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e1e1e1;
}

ul.list-creator li:nth-child(n + 2) {
  padding-top: 0.5rem;
}

hr.custom-hr {
  border: 0;
  border-top: 1.4px solid #1e1e1e;
  margin: 1em 0;
  padding: 0;
}

.content-memo {
  text-align: justify;
  margin-bottom: 1.4rem;
}

.content-memo strong {
  font-size: 16px;
}

.content-memo i {
  font-size: 16px;
}

.content-memo div {
  font-size: 14px;
}

.imgWaterMark-fully-approved {
  width: 7%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.imgWaterMark-on-approval {
  width: 8%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.text-rotate {
  position: absolute;
  right: 0;
  font-size: 60px;
  font-weight: 600;
  transform: rotate(90deg);
}

.im-withdraw {
  color: rgba(237, 27, 36, 0.1);
  top: 210px;
  right: -120px;
}

.im-rejected {
  color: rgba(237, 27, 36, 0.1);
  top: 190px;
  right: -110px;
}

.im-fully-approved {
  color: rgba(17, 182, 54, 0.1);
  top: 160px;
  right: -140px;
}

.im-on-approval {
  color: rgba(250, 255, 0, 0.1);
  top: 170px;
  right: -125px;
}

.im-draft {
  color: rgba(79, 79, 79, 0.1);
  top: 150px;
  right: -120px;
}

.v-toolbar__content {
  height: 48px;
}

div.divFooter {
  display: none;
}

.imgWaterMarkPrint {
  display: none;
}

.im-draft-print {
  display: none;
}

.imgWaterMark-fully-approved-print {
  display: none;
}

.imgWaterMark-on-approval-print {
  display: none;
}

.im-withdraw-print {
  display: none;
}

.im-rejected-print {
  display: none;
}

.im-fully-approved-print {
  display: none;
}

.im-on-approval-print {
  display: none;
}

.imgWaterMark-rejected-print {
  display: none;
}

.imgWaterMarkPrint-withdraw-print {
  display: none;
}

.height-60px {
  height: 60px;
  width: auto;
}

td.custom-td {
  vertical-align: middle;
}

td.custom-td img {
  vertical-align: middle;
  display: inline-block;
  margin-right: 0.6rem;
}

td.custom-td .inline-block {
  vertical-align: middle;
  display: inline-block;
}

td.custom-td .tagline {
  text-align: left;
}

.logo-title {
  font-size: 22px;
  font-weight: 600;
  color: #121212;
  margin-bottom: -0.4rem;
  text-align: left;
}

/** ============= CSS WATERMARK DINAMIS =========== **/

.img-wm {
  position: relative;
}

.img-wm__default img {
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;

  position: absolute;
  top: 0;
  left: 98%;
  width: 500px;
  height: auto;
  opacity: 0.3;
}

.img-wm__position-left img {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
}

.img-wm__position-center img {
  position: absolute;
  top: 0;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  opacity: 0.3;
}

.img-wm__position-right img {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.3;
}

.img-wm__size-xl img {
  width: 500px;
  height: auto;
}

.img-wm__size-l img {
  width: 250px;
  height: auto;
}

.img-wm__rotate-90-left img {
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 25%;
}

.img-wm__rotate-90-center img {
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 60%;
}

.img-wm__rotate-90-right img {
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: left top;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: left top;
  -ms-transform: rotate(90deg);
  -ms-transform-origin: left top;
  -o-transform: rotate(90deg);
  -o-transform-origin: left top;
  transform: rotate(90deg);
  transform-origin: left top;
  left: 95%;
}

.show-dinamis-wm {
  display: none;
}
</style>

<style>
.ck-content .image > img {
  display: block;
  margin: 0 auto;
  max-width: 80% !important;
}
</style>

<style scoped>
#1 {
  margin: 0%;
  height: 100vh;
}

.imPayBox {
  display: flex;
  width: 100%;
  padding: 0.2rem;
  max-width: 700px;
}
.imPayTTL {
  width: 40%;
}
.imPayText {
  flex: 1;
  color: var(--text-opacity-primary, rgba(0, 0, 0, 0.87));
  font-size: 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: justify;
}

.v-money {
  text-align: right;
}
</style>
